import React, { Component} from 'react';
import { connect } from 'react-redux';

import Navbar from '../components/Navbar';
import Aux from './auxi';
import SideBar from '../components/sideBar';
import Footer from '../components/Footer';
import Context from '../context';
import RGPDOptions from '../containers/rgpdOptions';
import Header from '../components/header';


class Layout extends Component {
    static context = Context;

    render() {

        let main = null;
        //console.log("children ----> " + JSON.stringify(this.props.children));
        //console.log("firsttime ----> " + this.props.firstTimeSign);
        if(this.props.isAuth) {
            if (this.props.firstTimeSign) {
                main = (
                    <div className="row">
                        <Header/>
                        {this.props.children}
                    </div>
                )
            } else {
                main = (
                    <div>
                        <Navbar isDirector={this.props.isDirector} isAuth={this.props.isAuth}
                                isAdmin={this.props.isAdmin} isQuest={this.props.isQuest}/>
                        <div className="row">
                            <div className="container col-3">
                                <SideBar/>
                            </div>
                            <div className="container col-sm-9">
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                )
            }
        }
        else{
            main = (
                <div>
                    <Navbar isDirector={this.props.isDirector} isAuth={this.props.isAuth}  isAdmin={this.props.isAdmin} isQuest={this.props.isQuest} />
                    <div className="container col-12">
                            {this.props.children}
                    </div>
                </div>
                )
            }
        return (
            <Aux>
                <main>
                    {main}
                </main>
                <Footer/>
            </Aux>
        )
    }
}

const mapStateToProps = state => {
    return {
        isAuth: state.login.profile != 5,
        isUser: state.login.profile == 1,
        isAdmin: state.login.profile == 2,
        isDoctor: state.login.profile == 3,
        isDirector: state.login.profile == 4,
        isVisitor: state.login.profile == 5,
        isQuest: state.login.profile == 6,
        profile: state.login.profile,
        firstTimeSign: state.login.firstTime
    };
};

export default connect(mapStateToProps, null)(Layout);



// WEBPACK FOOTER //
// ./src/hoc/Layout.js